<template>
  <q-banner 
    v-if="showBanner" 
    class="bg-warning text-dark password-compromise-banner"
  >
    <template v-slot:avatar>
      <q-icon name="security" color="dark" size="md" />
    </template>
    
    <div class="row items-center justify-between full-width">
      <div class="col-12 col-md q-mb-sm q-mb-md-none">
        Your password is not secure. For better security, please choose a different password.
      </div>
      <div class="col-auto">
        <q-btn 
          flat 
          color="dark" 
          label="Change Password" 
          :to="changePasswordRoute"
          class="q-mr-sm"
        />
        <q-btn 
          flat 
          color="dark" 
          icon="close"
          round
          dense
          @click="dismissBanner"
          aria-label="Dismiss"
        />
      </div>
    </div>
  </q-banner>
</template>

<script>
import { computed } from 'vue'
import { useSessionStore } from '../stores/session'
import { storeToRefs } from 'pinia'

export default {
  name: 'PasswordCompromiseBanner',
  
  props: {
    // Optional: custom route for change password
    changePasswordRoute: {
      type: [String, Object],
      default: '/profile'
    }
  },
  
  setup() {
    const sessionStore = useSessionStore()
    const { showPasswordCompromiseBanner } = storeToRefs(sessionStore)
    
    const showBanner = computed(() => showPasswordCompromiseBanner.value)
    
    const dismissBanner = () => {
      sessionStore.dismissPasswordCompromiseBanner()
    }
    
    return {
      showBanner,
      dismissBanner
    }
  }
}
</script>

<style scoped>
.password-compromise-banner :deep(.q-banner__content) {
  flex: 1;
}
</style>
